import { useEffect, useState } from 'react';
import {
	ICommentsAverage,
	MAP_ZOOM_TYPE_INDEXES,
} from 'modules/admin-panel/pages/results/models';
import {
	getMarkerSizeExtremums,
	getMaxCount,
} from 'modules/admin-panel/pages/results/helpers/map/resultMapConfig';

export const useMapPointsSize = (
	zoomTypeIndex: number,
	markerList?: ICommentsAverage[] | null,
) => {
	const [maxCountValue, setMaxCountValue] = useState(0);
	const [sizeExtremums, setSizeExtremums] = useState(
		getMarkerSizeExtremums(maxCountValue),
	);

	useEffect(() => {
		// Update points sizes on the Dashboard Choose survey page only one time after markerList loaded
		if (markerList?.length && !maxCountValue) {
			setMaxCountValue(getMaxCount(markerList));
		}
	}, [markerList, maxCountValue]);

	useEffect(() => {
		if (!markerList?.length) return;
		// To increase points sizes on the Results pages for country and etc. zoom levels
		let increasingIndex = 0;
		if (zoomTypeIndex === MAP_ZOOM_TYPE_INDEXES.countryZoom) {
			increasingIndex = 1;
		}
		if (zoomTypeIndex > MAP_ZOOM_TYPE_INDEXES.countryZoom) {
			increasingIndex = 2;
		}

		const baseSizeExtremums = getMarkerSizeExtremums(maxCountValue);
		const maxCountForSelectedLocation =
			zoomTypeIndex === MAP_ZOOM_TYPE_INDEXES.worldZoom
				? baseSizeExtremums.maxCount
				: getMaxCount(markerList);

		setSizeExtremums({
			size: {
				min: baseSizeExtremums.size.min + increasingIndex,
				max: baseSizeExtremums.size.max + increasingIndex,
			},
			maxCount: maxCountForSelectedLocation,
		});
	}, [zoomTypeIndex, maxCountValue, markerList]);

	return sizeExtremums;
};
